let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kFVzK")).then(() => parcelRequire('bkdrw'));